/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  TargetGroupOutput,
  TargetGroupOutputFromJSON,
  TargetGroupOutputToJSON,
} from "./";

/**
 *
 * @export
 * @interface PackageExtended
 */
export interface PackageExtended {
  /**
   *
   * @type {number}
   * @memberof PackageExtended
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PackageExtended
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof PackageExtended
   */
  minDays?: number;
  /**
   *
   * @type {Array<TargetGroupOutput>}
   * @memberof PackageExtended
   */
  targetGroups: Array<TargetGroupOutput>;
}

export function PackageExtendedFromJSON(json: any): PackageExtended {
  return PackageExtendedFromJSONTyped(json, false);
}

export function PackageExtendedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PackageExtended {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    minDays: !exists(json, "minDays") ? undefined : json["minDays"],
    targetGroups: (json["targetGroups"] as Array<any>).map(
      TargetGroupOutputFromJSON,
    ),
  };
}

export function PackageExtendedToJSON(value?: PackageExtended | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
    minDays: value.minDays,
    targetGroups: (value.targetGroups as Array<any>).map(
      TargetGroupOutputToJSON,
    ),
  };
}
